module.exports = __webpack_public_path__ + "img/motobomba.46e37734.jpeg";